import { MenuItem, TextField } from "@mui/material";
import { useController } from "react-hook-form";

const CustomSingleSelectField = ({ field, control }) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });

  return (
    <TextField
      name={field.name}
      label={field.label}
      variant="outlined"
      select
      fullWidth
      helperText={fieldState.error?.message || field.help_text || ""}
      disabled={field.disabled}
      sx={{ display: field.hidden ? "none" : "block" }}
      error={!!fieldState.error}
      {...fieldProps}
      value={fieldProps.value || ""}
    >
      {field.choices?.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CustomSingleSelectField;
